/**
 * Method for converting form data to json
 * @param {HTMLFormElement} form
 * @returns {} containing the form data as json
 */
export function getFormData(form) {
  const formData = [...form.elements].reduce((acc, el) => {
    //if an element with the same name has already been read convert it into an array
    if (acc[el.name] != null) {
      //strings spread as a char array so we need to handle them separately.
      if (typeof acc[el.name] === "string") {
        let oldValue = acc[el.name]; //store the old value
        acc[el.name] = [oldValue]; // convert to an array containing the old value.
      }
      acc[el.name] = [...acc[el.name], el.value]; // add the new value.
    } else if (el.name) {
      acc[el.name] = el.value; //if not an element name we have seen before, just store it.
    }
    return acc;
  }, {});
  return formData;
}
